import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const CREATE_QUERY = print(gql`
  mutation DeleteCalendar($data: CreateCalendarInput!) {
    createCalendar(data: $data) {
      id
    }
  }
`);

export interface CreateGql {
  createCalendar: {
    id: number;
  };
}
